<template>
    <trax-ui-modal-plain-header :id="id+'-modal'" :bus="bus">

        <div :id="id" v-if="notification">
            
            <p v-if="notification.data.context.display.full" v-html="notification.data.context.display.full">
            </p>
            <p v-else-if="notification.data.context.display.compact" v-html="notification.data.context.display.compact" class="font-weight-bold">
            </p>

            <p>{{ trans(notification.data.content.message) }}</p>

            <div class="text-center mt-4 mb-3">

                <!-- Action button -->
                <a :href="url(notification.data.content.action.url)" class="btn btn-round btn-default" v-if="notification.data.content.action">
                    {{ trans(notification.data.content.action.label) }}
                </a>

                <!-- Delete button -->
                <button class="btn btn-round btn-danger" @click="deleteNotif">
                    {{ lang.polaris.notification.delete_message }}
                </button>

            </div>

        </div>

    </trax-ui-modal-plain-header>
</template>

<script>
    export default {
    
        props: {
            id: { default: 'trax-notification' },
        },
    
        data: function() {
            return {
                lang: lang,
                app_url: app_url,
                endpoint: app_url+"polaris/api/front/notifications",
                user: user,
                notification: null,
                bus: this.$bus
            }
        },

        created: function() {
            this.bus.$on(this.id+'-modal-open', this.opened);
        },

        methods: {
        
            opened: function(event) {
                this.notification = event.data;
                if (this.notification.read) return;

                // Record status
                var that = this;
                axios.put(
                    this.endpoint+'/'+this.notification.id+'/me',
                    { read: true }
                )
                .then(function (response) {
                    that.bus.$emit(that.id+'-notification-read', that.notification.id);
                })
                .catch(function (error) {
                });
            },

            deleteNotif: function(event) {
                var that = this;
                axios.delete(
                    this.endpoint+'/'+this.notification.id+'/me',
                )
                .then(function (response) {
                    that.bus.$emit(that.id+'-modal-close');
                    that.bus.$emit(that.id+'-notification-deleted', that.notification.id);
                })
                .catch(function (error) {
                });
            },

            trans(key) {
                return this.lang.polaris.notification[key.split('.').pop()]
            },

            url(url) {
                // Replace the TRAX path.
                var absoluteUrl = url.includes('/enac/ui')
                    ? this.app_url + (new URL(url)).pathname.replace('/enac/ui', 'polaris/ui')
                    : url

                // Be sure to target the current server domain. Usefull when the prod BD is moved on the test server.
                var parts = absoluteUrl.split('polaris/ui')
                absoluteUrl = this.app_url + 'polaris/ui' + parts[1]

                return absoluteUrl
            }
        }
    }
</script>
